<template>
  <v-navigation-drawer v-model="showDrawer" app clipped width="120" touchless :id="drawerId">
    <div v-for="(item, index) in MIX_filteredNav('SideNav')" :key="index">
      <v-list-item :disabled="MIX_checkLevelAndStatus(item)" @click="MIX_go(item.path)" class="text-center px-4">
        <v-list-item-content>
          <v-icon
            v-if="!MIX_checkLevelAndStatus(item)"
            class="grey--text text--darken-1"
            large
            :disabled="MIX_checkLevelAndStatus(item)"
          >
            {{ item.icon }}
          </v-icon>
          <div
            v-if="!MIX_checkLevelAndStatus(item)"
            :disabled="MIX_checkLevelAndStatus(item)"
            class="fullwidth text-center text-body-2 font-weight-bold grey--text text--darken-1"
          >
            {{ item.title }}
          </div>
        </v-list-item-content>
      </v-list-item>
    </div>

    <!-- Upload CSV nav item, visible only to admins, styled like other icons -->
    <v-list-item
      v-if="isAdmin"
      class="text-center px-4"
      @click="triggerFileInput"
    >
      <v-list-item-content>
        <v-icon
          class="grey--text text--darken-1"
          large
        >mdi-upload</v-icon>
        <div class="fullwidth text-center text-body-2 font-weight-bold grey--text text--darken-1">
          Upload CSV
        </div>
      </v-list-item-content>
    </v-list-item>
    <input
      type="file"
      ref="csvInput"
      style="display: none"
      accept=".csv"
      @change="uploadCsv"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SideNav",
  data: () => ({
    showDrawer: true,
  }),
  computed: {
    ...mapGetters({
      GET_showDrawer: "GET_showDrawer",
      GET_currentUserAuth: "GET_currentUserAuth",
      GET_currentUserProfile: "GET_currentUserProfile",
      GET_userAuthenticated: "GET_userAuthenticated",
    }),
    drawerId() {
      return this.$vuetify.breakpoint.width <= 1260 ? "height-top-margin" : "";
    },
    isAdmin() {
      return (
        this.GET_currentUserProfile &&
        this.GET_currentUserProfile.level &&
        this.GET_currentUserProfile.level.toLowerCase() === "administrator"
      );
    },
  },
  watch: {
    GET_showDrawer: function () {
      this.showDrawer = this.GET_showDrawer;
    },
    showDrawer: function () {
      this.ACT_showDrawer(this.showDrawer);
    },
  },
  methods: {
    ...mapActions({
      ACT_showDrawer: "ACT_showDrawer",
    }),
    triggerFileInput() {
      this.$refs.csvInput.click();
    },
    async uploadCsv(event) {
      const file = event.target.files[0];
      if (!file) {
        alert("No file selected.");
        return;
      }
      const formData = new FormData();
      formData.append('file', file);
      try {
        const res = await fetch('/api/v1/csv/upload-csv', {
          method: 'POST',
          body: formData,
        });
        if (!res.ok) throw new Error(await res.text());
        const result = await res.json();
        alert(`Upload complete!\nAdded: ${result.added}\nSkipped: ${result.skipped}`);
      } catch (err) {
        alert("Upload failed: " + err.message);
      }
    }
  }
};
</script>

<style scoped>
#height-top-margin {
  margin-top: 60px; /* Height of the top navigation bar */
}
</style>
